import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { EDIT_HEATMAPS, EDIT_SESSION_RECORDINGS } from 'shared/constants/permissions';
import Heatmap from './Heatmap';
import HsrDashboard from './HsrDashboard';
import SessionRecording from './SessionRecording';
import HeatmapList from './HeatmapList';
import SessionRecordingList from './SessionRecordingList';
import SessionRecordingReplay from './SessionRecordingReplay';

const routes = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    component: HsrDashboard,
  },
  {
    path: 'heatmaps',
    label: 'Heatmaps',
    link: false,
    component: Heatmap,
    emptyLabel: 'No heatmaps',
    activeEmptyLabel: 'No active heatmaps',
  },
  {
    path: 'session-recordings/:matomoHsrId/:recordId',
    component: SessionRecordingReplay,
  },
  {
    path: 'session-recordings',
    label: 'Recordings',
    link: false,
    component: SessionRecording,
    emptyLabel: 'No recordings',
    activeEmptyLabel: 'No active session recordings',
  },
  {
    type: 'divider',
  },
  {
    path: 'manage-heatmaps',
    label: 'Manage heatmaps',
    icon: <EditOutlined />,
    component: HeatmapList,
    dataSourcePermission: EDIT_HEATMAPS,
  },
  {
    path: 'manage-session-recordings',
    label: 'Manage recordings',
    icon: <EditOutlined />,
    component: SessionRecordingList,
    dataSourcePermission: EDIT_SESSION_RECORDINGS,
  },
];

export default routes;
